<template>
  <i-modal
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="コンバート送信結果詳細"
    width="780"
    :mask-closable="false"
    footer-hide
    class="modal-convert-detail"
  >
    <div class="container">
      <div class="shop_name">
        {{ result.shop_name }}
      </div>
      <i-button
        v-if="result.download_link !== ''"
        type="primary"
        size="small"
        icon="ios-download"
        target="_blank"
        :to="result.download_link"
      >
        結果ファイルをダウンロード
      </i-button>
    </div>
    <!-- サイトがyahooの場合 且つ 結果データが存在する場合 -->
    <template v-if="result.portalsite_cd === 'yahoo' && result.result_data.length > 0">
      <YahooConvertResult
        :result="result.result_data"
        :date="result.ended_date"
      />
    </template>
    <template v-else>
      <div class="result_log" v-html="result.total_str"></div>
    </template>
  </i-modal>
</template>

<script>
import { Modal, Button } from 'view-design'
import ConvertRepository from '@/repositories/convertRepository'
import YahooConvertResult from '@/components/templates/YahooConvertResult'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    YahooConvertResult
  },
  data() {
    return {
      result: {},
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalConvertDetail/getModal']
      },
      set(val) {
        this.$store.commit('ModalConvertDetail/setModal', val)
      },
    },
    resultId() {
      return this.$store.getters['ModalConvertDetail/getResultId']
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        this.getDetail()
      } else {
        setTimeout(this.resetParam, 300)
      }
    },
    async getDetail() {
      this.$store.dispatch('Loading/setLoading', true)
      await ConvertRepository.getDetail(this.resultId)
        .then(res => {
          if (res.result) {
            this.result = res.data
          } else {
            alert('データ取得に失敗しました。')
            this.modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('データ取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パラメータをリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.$store.dispatch('ModalConvertDetail/reset')
    },
  },
}
</script>

<style lang="scss">
.modal-convert-detail {
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .shop_name {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: bold;
  }
  .result_log {
    padding: 8px;
    background-color: #f0f0f0;
    border: 1px solid #cfcfcf;
    font-size: 14px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
.alert_msg {
  font-size: 14px !important;
}
</style>
